{
  "datatable": {
    "rowsPerPage": "Filas por página"
  },
  "department": {
    "addDepartment": "Añadir Departamento",
    "createNewDepartment": "Crear Nuevo Departamento",
    "departmentAdmin": "Administrador del Departamento",
    "departmentName": "Nombre del Departamento",
    "institution": "Nombre de la Institución",
    "institutionName": "Nombre de la Institución",
    "searchDepartments": "Buscar Departamento(s)",
    "thisFieldIsRequired": "Este campo es obligatorio"
  },
  "general": {
    "accessDenied": "Acceso Denegado",
    "add": "Añadir",
    "back": "Atrás",
    "cancel": "Cancelar",
    "close": "Cerrar",
    "dateAdded": "Fecha Añadida",
    "dateUpdated": "Fecha Actualizada",
    "delete": "Eliminar",
    "edit": "Modificar",
    "loading": "Cargando ...",
    "no": "No",
    "noData": "Sin Datos",
    "ok": "Ok",
    "remove": "Remover",
    "save": "Guardar",
    "selectAll": "Seleccionar Todo",
    "yes": "Sí",
    "selectGender": "Seleccionar género",
    "gender": {
      "male": "Masculino",
      "female": "Femenino"
    }
  },
  "institution": {
    "contact": "Contacto",
    "createNewInstitution": "Crear Nueva Institución",
    "name": "Nombre",
    "region": "Región",
    "searchInstitutions": "Buscar institución(es)",
    "switch": "Cambiar",
    "switchedTo": "Las instituciones se cambiaron a",
    "unableToSwitch": "Imposible cambiar"
  },
  "menu": {
    "departments": "Departamentos",
    "home": "Inicio",
    "institutions": "Instituciones",
    "procedure": "Procedimiento",
    "procedures": "Procedimientos",
    "scheduling": "Programación",
    "users": "Usuarios"
  },
  "procedure": {
    "allSteps": "Todos los Pasos",
    "authors": "Autor",
    "category": "Categoría",
    "createNewStep": "Crear Nuevo Paso",
    "defineFeedback": "Definir Feedback",
    "description": "Descripción",
    "disableProcedure": "Inhabilitar Procedimiento",
    "addProceduresInformation": "Agregar Información del Procedimiento",
    "editProceduresInformation": "Editar la Información del Procedimiento",
    "duplicateStartEndStepWarning": "Solo se permite 1 paso de inicio y 1 de fin",
    "information": "Información",
    "language": "Idioma",
    "languagesAvailable": "Idiomas Disponibles",
    "media": "Imágenes y Videos",
    "name": "Nombre",
    "owner": "Propietario",
    "procedureCategory": "Categoría del Procedimiento",
    "procedureLanguage": "Idioma del Procedimiento",
    "procedureName": "Nombre del Procedimiento",
    "procedureNotFound": "Procedimiento No Encontrado",
    "public": "Público",
    "publicPrivate": "Público/Privado",
    "revisionHistory": "Historial de Revisiones",
    "searchSteps": "Buscar Paso(s)",
    "seeFeedback": "Ver Feedback",
    "statistics": "Estadísticas",
    "step": "Paso",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "unableToLoad": "No se puede cargar el procedimiento",
    "viewAs": "Ver Como"
  },
  "procedures": {
    "addProcedure": "Añadir procedimiento",
    "category": "Categoría",
    "deleteProcedure": "Eliminar Procedimiento",
    "department": "Departamento",
    "filter": "Filtrar",
    "private": "Privado",
    "procedures": "Procedimientos",
    "public": "Público",
    "publicPrivate": "Público/Privado",
    "searchProcedures": "Buscar procedimientos",
    "sort": "Clasificar"
  },
  "step": {
    "addDescription": "Agregar descripción",
    "addParentStep": "Añadir paso principal",
    "chooseParentSep": "Elegir el paso principal",
    "chooseStepOption": "Elegir opción del paso",
    "chooseTransitionType": "Elegir el tipo de transición",
    "chooseType": "Elige tipo",
    "description": "Descripción",
    "dropFilesOrClickToUpload": "Suelta los archivos aquí o haz clic para subir",
    "editStep": "Editar Paso",
    "insertMaxValue": "Insertar valor máximo (MAX)",
    "insertMinValue": "Insertar valor mínimo (MIN)",
    "insertOption": "Insertar opción",
    "option": "Opción",
    "owner": "Propietario",
    "parentStep": "Paso principal",
    "previousStep": "Paso anterior",
    "saveMedia": "Guardar Imágenes y Vídeos del paso",
    "stepMedia": "Imágenes y Vídeos del Paso",
    "transitionToNextStep": "Transición al siguiente paso",
    "transitionType": "Tipo de transición",
    "type": "Escribir",
    "value": "Valor",
    "viewInProcedure": "Ver en el Procedimiento",
    "error": {
      "WONT_REACH_END": "Sin ruta al FINAL",
      "EXIT_NOT_IN_USE": "Salida no utilizada",
      "NO_PARENT_SET": "No tiene paso anterior",
      "PARENT_NOT_EXITS": "El paso padre definido no existe",
      "DUPLICATE_START": "El procedimiento solo puede tener un paso de INICIO",
      "DUPLICATE_END": "El procedimiento solo puede tener un paso de FIN"
    }
  },
  "user": {
    "accountSettings": "Ajustes de la Cuenta",
    "chooseUserRole": "Elegir Rol del Usuario",
    "contact": "Contacto",
    "contactInformation": "Información de Contacto",
    "dateOfBirth": "Fecha de Nacimiento",
    "department": "Departamento",
    "emails": "Correo(s) Electrónico(s) del Usuario",
    "emailsDescription": "Inserte 1 o más correos electrónicos, separados por punto y coma. Las invitaciones para registrarse como el rol de usuario elegido se enviarán a los usuarios por correo electrónico.",
    "filter": "Filtrar",
    "gender": "Género",
    "institution": "Institución",
    "institutionalAdmin": "Administrador de la Institución",
    "institutionAndDepartment": "Institución y Departamento",
    "inviteUsers": "Invitar Usuarios",
    "logOut": "Cerrar sesión    ",
    "nurse": "Enfermero/a",
    "password": "Contraseña",
    "patient": "Paciente",
    "resetPassword": "Restablecer la Contraseña",
    "resetRequestSentTo": "Correo electrónico de restablecimiento de contraseña enviado a",
    "searchUsers": "Buscar Usuario(s)",
    "sendResetPasswordEmailTo": "Enviar correo electrónico de restablecimiento de contraseña a",
    "sort": "Clasificar",
    "subscription": "Suscripción",
    "thisFieldIsRequired": "Este campo es obligatorio",
    "user": "Usuario",
    "userDetailsUpdated": "Datos de usuario actualizados",
    "userInformation": "Información del Usuario",
    "userRole": "Rol del Usuario"
  },
  "approvalRequest": {
    "actionType": "Action Type",
    "requestedBy": "Requested By",
    "approvedBy": "Approved By",
    "confirms": {
      "approveTitle": "Approve request",
      "approveText": "Are you sure you want to approve this request?",
      "rejectTitle": "Reject request",
      "rejectText": "Please provide a reason for rejecting this request.",
      "rejectReasonPlaceholder": "Rejection reason"
    },
    "actionTypes": {
      "PERMISSION_GRANT": "Permission Grant",
      "PERMISSION_REVOKE": "Permission Revoke",
      "EXPORT_VISITS": "Export Visits",
      "EXPORT_LOCATION_HISTORY": "Export Location History",
      "EXPORT_ARRIVAL_HISTORY": "Export Arrival History",
      "ENABLE_USER": "Enable User",
      "DISABLE_USER": "Disable User"
    },
    "toasts": {
      "created": "Approval request created",
      "applied": "Action applied",
      "applyFailed": "Failed to apply action",
      "approved": "Request approved",
      "approveFailed": "Failed to approve request",
      "rejected": "Request rejected",
      "rejectFailed": "Failed to reject request"
    }
  }
}
